import React from "react";
import { useTranslation } from "react-i18next";
const CharacterCount = (props) => {
  const { characterCount, maxLength } = props;
  const { t } = useTranslation();
  return /* @__PURE__ */ React.createElement("p", { className: "form-character-counter" }, characterCount, "/", maxLength, " ", t("form.input.characters"));
};
export default CharacterCount;
